var map = {
	"./1.jpg": 81,
	"./10.jpg": 781,
	"./11.jpg": 9648,
	"./12.jpg": 3263,
	"./13.jpg": 882,
	"./14.jpg": 6369,
	"./15.jpg": 8324,
	"./16.jpg": 2483,
	"./17.jpg": 6022,
	"./18.jpg": 1509,
	"./19.jpg": 7992,
	"./2.jpg": 9734,
	"./20.jpg": 2092,
	"./3.jpg": 6195,
	"./4.jpg": 3360,
	"./5.jpg": 4493,
	"./6.jpg": 4594,
	"./7.jpg": 6975,
	"./8.jpg": 5260,
	"./9.jpg": 3305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3957;